import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import styles from './codeWrapper.scss';
import modalUtils from '../../../../../qti/utils/ModalUtils';
import ExtendedTextCodeCompilerSamples from './ExtendedTextCodeCompilerTestCases';
import sessionReader from '../../../../../store/readHelpers/SessionReader';
import { t } from '../../../../../services/i18nService';
import globalsService from '../../../../../services/GlobalsService';

class ExtendedTextCodeCompilerModal extends React.Component {
    static propTypes = {
        closeHandler: PropTypes.func.isRequired,
        codeCompilerClickHandler: PropTypes.func,
        mode: PropTypes.string.isRequired,
        runTimeInfo: PropTypes.object,
        sampleTestCases: PropTypes.array,
        sampleTestCasesResults: PropTypes.array,
        evalTestCases: PropTypes.array,
        evalTestCasesResults: PropTypes.array,
        error: PropTypes.object,
    };

    closeModal = () => {
        this.props.closeHandler();
    };

    getModalContents = () => {
        const { mode } = this.props;
        if (mode === 'results') {
            return this.drawResultsTable();
        } else if (mode === 'results_eval') {
            return this.drawResultsEvalTable();
        } else if (mode === 'compiling') {
            return this.drawCompilingMode();
        } else if (mode === 'error' || mode === 'httpError' || mode === 'compilationError') {
            return this.drawErrorMode();
        }
        return false;
    };

    drawCompilingMode = () => {
        const assetRoot = globalsService.getAssetRoot();
        const src = `${!assetRoot ? '' : `${assetRoot}/`}images/loading-spinner.svg`;
        return (
            <div className={styles.compile}>
                <h3>{t('codeCompiler.compiling')}</h3>
                <div>
                    <svg>
                        <title>{t('codeCompiler.compiling')}</title>
                        <image href={src} height="100%" width="100%" />
                    </svg>
                </div>
                <p>{t('codeCompiler.pleaseWait')}</p>
            </div>
        );
    };

    returnErrorInformation = () => {
        const { mode, runTimeInfo, error } = this.props;
        if (mode === 'compilationError') {
            return (
                <React.Fragment>
                    <p><strong>{t('codeCompiler.reason')}</strong></p>
                    <code>
                        {runTimeInfo.cmperr}
                    </code>
                </React.Fragment>
            );
        } else if (mode === 'httpError') {
            return (
                <React.Fragment>
                    <p>{t('codeCompiler.techProblem')}</p>
                    <h4>{`${error.statusCode}: ${error.statusText}`}</h4>
                    <p><strong>{t('codeCompiler.tryAgain')}</strong></p>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <p>{t('codeCompiler.error')}</p>
                <h4>{error.statusText}</h4>
                <p><strong>{t('codeCompiler.tryAgain')}</strong></p>
            </React.Fragment>
        );
    };

    drawErrorMode = () => {
        return (
            <div className={styles.error}>
                <h3>{t('codeCompiler.weAreSorry')}</h3>
                <i className="fa fa-close fa-4x" aria-hidden="true" />
                {this.returnErrorInformation()}
            </div>
        );
    };


    drawResultsTable = () => {
        const { mode, sampleTestCases, sampleTestCasesResults } = this.props;
        return (
            <div className={styles.result}>
                <div className={styles.modalHeader}>
                    <h3>{t('codeCompiler.sampleResultsHeader')}</h3>
                </div>
                <ExtendedTextCodeCompilerSamples
                    mode={mode}
                    testCases={sampleTestCases}
                    testCasesResults={sampleTestCasesResults}
                />
            </div>
        );
    };

    drawResultsEvalTable = () => {
        const { mode, evalTestCases, evalTestCasesResults } = this.props;
        return (
            <div className={styles.result}>
                <div className={styles.modalHeader}>
                    <h3>{t('codeCompiler.evalResultsHeader')}</h3>
                </div>
                <ExtendedTextCodeCompilerSamples
                    mode={mode}
                    testCases={evalTestCases}
                    testCasesResults={evalTestCasesResults}
                />
            </div>
        );
    };

    codeCompilerClickHandler = (event) => {
        const { codeCompilerClickHandler } = this.props;
        codeCompilerClickHandler(event);
    };

    displaySampleOrEvalLink = () => {
        const { mode } = this.props;

        if (!sessionReader.isContextPreview()) {
            return null;
        } else if (mode === 'results') {
            return (
                <button
                    className={`btn ${styles.compileBtn}`}
                    onClick={this.codeCompilerClickHandler}
                    id="evaluateCode"
                >
                    {t('codeCompiler.testValidationEvalTestCases')}
                </button>
            );
        } else if (mode === 'results_eval') {
            return (
                <button
                    className={`btn ${styles.compileBtn}`}
                    onClick={this.codeCompilerClickHandler}
                >
                    {t('codeCompiler.testValidationSampleTestCases')}
                </button>
            );
        }
        return null;
    };

    render() {
        return (
            <Modal
                isOpen
                style={modalUtils.codeCompilerModalStyles}
            >
                {this.getModalContents()}
                <div className={styles.modalFooter}>
                    {this.displaySampleOrEvalLink()}
                    <button className={`${styles.close} btn`} onTouchEnd={this.closeModal} onClick={this.closeModal}>
                        {t('codeCompiler.close')}
                    </button>
                </div>
            </Modal>
        );
    }
}

export default ExtendedTextCodeCompilerModal;
